export default __webpack_public_path__ + "static/media/CIO_Award.c32b8e3b.pdf";